module.exports = __webpack_public_path__ + "img/smile.82b84d01.svg";